import { BehaviorSubject }  from 'rxjs';
import {
  BrandService,
  MapCoord,
	MapFilter,
	HTTPCallback,
  TokenService,
	SearchResult,
	SearchInterface,
	UtilityService
}												    from './';
import {
  Inject,
  Injectable
}                           from '@angular/core';

@Injectable()
export class BackendService implements SearchInterface {
  private doorbell: any;
  doorbellReady: () => void;
	doorbellReadyContext: any;

  constructor(
    private brandService:   BrandService,
    private tokenService:   TokenService,
    private utilityService: UtilityService
  ) {
    (<any>window).doorbellOptions = { appKey: brandService.doorbellKey };

    utilityService.injectScript(
      'https://embed.doorbell.io/button/' + brandService.doorbellAppID + '?t=' +
        (new Date().getTime()),
      'doorbell',
      doorbell => {
        this.doorbell = doorbell;
        this.doorbellReady.call(this.doorbellReadyContext);
      },
      this
    );

    console.log('Backend service created');
  }

	getConfig(callback: HTTPCallback, context: any) {
    this.makeBackendRequest('config', (data: any) => {
      callback.call(context, data.config);
    });
	}

	getFilters(callback: HTTPCallback, context: any) {
    this.makeBackendRequest('filters', (data: any) => {
      callback.call(context, data.filters);
    });
	}

	getGeofence(geofence: string, position: any, callback: any, context: any) {
		this.makeBackendRequest('geofence', (data: any) => {
			callback.call(context, data.property);
		}, {
			geofence: geofence,
			coordinates: position
		});
	}

  getImage(value: string, defaultValue?: string): string {
    if (value.length > 0) {
      let tempValue = value.replace(' ', '_') + '.svg';

      return this.brandService.baseUrl + 'img/' + this.brandService.brandName + '/' + tempValue;
    } else {
      return typeof defaultValue === 'string' ? defaultValue : '';
    }
  } 

	getLegend(callback: HTTPCallback, context: any) {
    this.makeBackendRequest('legend', (data: any) => {
      callback.call(context, data.legend);
    });
	}

	getMapCoordinates(
    layer:      string,
    resolution: string,
    callback:   (coords: any, resolution: string) => void,
    context:    any
  ) {
    var startTime = new Date().getTime();
		this.makeBackendRequest('layers/' + layer + '/coordinates/' + resolution, (data: any) => {
      callback.call(context, data.coordinates, resolution);
      console.log(new Date().getTime() - startTime);
		});
	}

  getMapLayers(callback: HTTPCallback, context: any) {
    this.makeBackendRequest('layers', (data: any) => {
      callback.call(context, data.layers);
    });
  }

	getMapProperties(layer: string, feature: number, callback: HTTPCallback, context: any) {
		this.makeBackendRequest('layers/' + layer + '/properties/' + feature, (data: any) => {
			callback.call(context, data.properties);
		});
	}

  getSearchResult(query: string, callback: any, context: any) {
    this.makeBackendRequest('search-address', data => {
      if (typeof data.search_result === 'object') {
        callback.call(context, new SearchResult(data.search_result));
      } else {
        callback.call(context);
      }
    }, { query: query });
  }

	makeBackendRequest(endpoint: string, callback: HTTPCallback, parameters?: any) {
		this.tokenService.getToken(newToken => {
			if (typeof parameters === 'undefined') {
        this.utilityService.httpGet(
          this.brandService.baseUrl + endpoint,
          data => {
            if (typeof data.error === 'string') {
              console.log(data.error);

              if (data.error.indexOf('Invalid token') > -1) {
                this.tokenService.getNewToken();

                this.makeBackendRequest(endpoint, callback, parameters);
              } else {
                callback({});
              }
            } else {
              callback(data);
            }
          },
          this,
          { token: newToken }
        );
			} else {
				this.utilityService.httpPost(
          this.brandService.baseUrl + endpoint,
          parameters,
          data => {
            if (typeof data.error === 'string') {
              console.log(data.error);

              if (data.error.indexOf('Invalid token') > -1) {
                this.tokenService.getNewToken();

                this.makeBackendRequest(endpoint, callback, parameters);
              } else {
                callback({});
              }
            } else {
              callback(data);
            }
          },
          this,
          { token: newToken }
        );
			}
		});
	}

  showSupportPopup() {
    this.doorbell.show();
  }
}



// WEBPACK FOOTER //
// ./src/app/electraLib/service/backend.service.ts